import React from "react";

import "./intro.css";

const Intro = () => {
  return (
  <div className="mainintro">
  <div className="intro">

  <div className="f-name "> Chandel Bangles</div>
  <div className="l-name"> ONE STOP-STOP DESTINATION FOR BEAUTIFULLY HANDCRAFTED BANGLES</div>

</div></div>
  );
};

export default Intro;
